import { createAction, props } from '@ngrx/store';
import { TeamType, CreateTeamTypeDto, UpdateTeamTypeDto } from '@/models/team-type.model';

// Load TeamTypes Actions
export const loadTeamTypes = createAction('[TeamType] Load TeamTypes');
export const loadTeamTypesSuccess = createAction('[TeamType] Load TeamTypes Success', props<{ teamTypes: TeamType[] }>());
export const loadTeamTypesFailure = createAction('[TeamType] Load TeamTypes Failure', props<{ error: any }>());

// Create TeamType Actions
export const createTeamType = createAction('[TeamType] Create TeamType', props<{ teamType: CreateTeamTypeDto }>());
export const createTeamTypeSuccess = createAction('[TeamType] Create TeamType Success', props<{ teamType: TeamType }>());
export const createTeamTypeFailure = createAction('[TeamType] Create TeamType Failure', props<{ error: any }>());

// Update TeamType Actions
export const updateTeamType = createAction('[TeamType] Update TeamType', props<{ id: number; teamType: UpdateTeamTypeDto }>());
export const updateTeamTypeSuccess = createAction('[TeamType] Update TeamType Success', props<{ teamType: TeamType }>());
export const updateTeamTypeFailure = createAction('[TeamType] Update TeamType Failure', props<{ error: any }>());

export const resetCreateTeamTypeStatus = createAction('[TeamType] Reset Create TeamType Status');
export const resetUpdateTeamTypeStatus = createAction('[TeamType] Reset Update TeamType Status');
